"use client"

import { useState, useEffect } from "react"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import Login from "./components/Login"
import AdminDashboard from "./components/admin/AdminDashboard"
import MentorDashboard from "./components/mentor/MentorDashboard"
import { apiService } from "./services/apiService"
import "./App.css"

function App() {
  const [user, setUser] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // Check if user is already authenticated
    const checkAuth = async () => {
      try {
        if (apiService.isAuthenticated()) {
          // Get current user data
          const userData = await apiService.getCurrentUser();
          setUser(userData);
        }
      } catch (error) {
        console.error('Auth check error:', error);
        await handleLogout();
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleLogin = (userData) => {
    setUser(userData)
  }

  const handleLogout = async () => {
    await apiService.logout()
    setUser(null)
  }

  if (isLoading) {
    return <div className="loading">Loading...</div>
  }

  return (
    <Router>
      <div className="app">
        <Routes>
          <Route
            path="/"
            element={
              !user ? (
                <Login onLogin={handleLogin} />
              ) : user.user_type === "admin" ? (
                <Navigate to="/admin" />
              ) : (
                <Navigate to="/mentor" />
              )
            }
          />
          <Route
            path="/admin/*"
            element={
              user && user.user_type === "admin" ? (
                <AdminDashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/mentor/*"
            element={
              user && user.user_type === "mentor" ? (
                <MentorDashboard user={user} onLogout={handleLogout} />
              ) : (
                <Navigate to="/" />
              )
            }
          />
        </Routes>
      </div>
    </Router>
  )
}

export default App
